const inkeep_ai_bot = {
    intro_message: "Xin chào, tôi là sdvico AI!\n\nTôi là một trợ lý AI được huấn luyện trên tài liệu, bài viết hỗ trợ và các nội dung khác.\n\nHãy hỏi tôi bất cứ điều gì về `sdvico`.",
    chat_placeholder: 'Hỏi sdvico AI câu hỏi của bạn để nhận hướng dẫn từng bước',
    disclaimer_label: 'Tuyên bố miễn trừ trách nhiệm của sdvico AI',
    disclaimer_tooltip: 'Các câu trả lời được tạo bởi AI và có thể cần được kiểm chứng thêm.',
    example_questions_label: 'Câu hỏi ví dụ',
    example_questions: [
        'Hướng dẫn khởi động nhanh để thiết lập sdvico',
        'Cấu hình kiến trúc đa tenant',
        'Cách tích hợp hồ sơ người dùng?',
    ],
    stop: 'Dừng',
    clear: 'Bắt đầu lại',
    get_help: 'Nhận trợ giúp',
    copy_chat: 'Sao chép',
    ask_ai_label: 'Hỏi AI',
    contact: 'Liên hệ',
    discord: 'Discord',
};
export default Object.freeze(inkeep_ai_bot);
